<script lang="ts" setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/user'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { getErrorCode } from '@/app/core/composable/general'
import { useI18n } from 'vue-i18n'
import Popper from 'vue3-popper'
import { DTable, DLoading, SearchMdIcon, Edit03Icon } from 'front-library'
import {
  CountryParameter,
  getCountryParameters
} from '@/app/core/services/country-parameters'
usePayrollChange(() => window.location.reload())

/* store, router, notifications */
const router = useRouter()
const store = useUserStore()
const notifications = useNotificationsStore()
const { t } = useI18n()

/* Datos componente Loading */
const loading = ref(false)

/* Datos */
const search = ref()

/* Datos componente table */
const columns = ref([
  { name: 'code', title: t('countryParameters.list.code'), table: 'code' },
  { name: 'name', title: t('countryParameters.list.name'), table: 'name' },
  { name: 'type', title: t('countryParameters.list.type'), table: 'type' },
  {
    name: 'last_applies_from',
    title: t('countryParameters.list.appliesFrom'),
    table: 'last_applies_from'
  },
  { name: 'actions', title: '' }
])
const rows = ref<CountryParameter[]>([])
const perPage = ref(0)
const offset = ref(0)
const totalRows = ref(0)
const sortBy = ref('')

/* Redirect's */
const getCountryParameter = (id: any) => {
  void router.push({ name: 'GetCountryParameter', params: { id } })
}
const updateCountryParameter = (id: any) => {
  void router.push({ name: 'UpdateCountryParameter', params: { id } })
}

/* Listar listas de festivos */
const countryParameters = async () => {
  loading.value = true
  try {
    const data: any = await getCountryParameters(
      offset.value,
      perPage.value,
      sortBy.value,
      search.value === '' ? undefined : search.value
    )
    rows.value = data.results
    totalRows.value = data.totalItems
    loading.value = false
  } catch (error: any) {
    loading.value = false
    const code = getErrorCode(error.response.data?.code)
    notifications.addNotification({
      title: t('error.titles.' + code),
      text: t('error.messages.' + code),
      type: 'error',
      time: 10000
    })
  }
}
</script>
<template>
  <DLoading v-show="loading" :message="t('loading.data')" />
  <div class="h-full px-5 overflow-auto scroll">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow"
          v-html="t('countryParameters.list.title', 1)" />
        <p
          class="text-gray-500 text-shadow"
          v-html="t('countryParameters.list.description')" />
      </div>
    </div>
    <DTable
      ref="tableListHoliday"
      :columns="columns"
      :rows="rows"
      :total-rows="totalRows"
      :select-options="false"
      :text-no-data="t('table.noData')"
      :text-per-page="t('table.rowsPerPage')"
      @perPage=";(perPage = $event), countryParameters()"
      @offset="offset = $event"
      @sort=";(sortBy = $event), countryParameters()">
      <template #actions="data: any">
        <div class="flex py-2.5 justify-end gap-1">
          <Popper
            v-if="store.hasPermission('country_parameter:get')"
            arrow
            offsetDistance="12"
            :content="t('table.action.detail')"
            :hover="true"
            placement="top"
            class="tooltip">
            <div
              class="bg-gray-50 rounded-md py-2"
              @click="getCountryParameter(data.id)">
              <SearchMdIcon class="h-6 w-6 mx-2 cursor-pointer text-gray-600" />
            </div>
          </Popper>
          <Popper
            v-if="store.hasPermission('country_parameter:update')"
            arrow
            offsetDistance="12"
            :content="t('table.action.edit')"
            :hover="true"
            placement="top"
            class="tooltip">
            <div
              class="bg-gray-50 rounded-md py-2"
              @click="updateCountryParameter(data.id)">
              <Edit03Icon class="h-6 w-6 mx-2 cursor-pointer text-gray-600" />
            </div>
          </Popper>
        </div>
      </template>
    </DTable>
  </div>
</template>
